import type { FC } from 'react';
import { HelperText } from 'react-native-paper';
import Styles from 'src/core/utils/Styles';

interface Props {
	message?: string | string[] | null | undefined;
}

const FieldError: FC<Props> = ({ message }) => {
	const hasMessage = Array.isArray(message) ? message.length > 0 : Boolean(message);

	return (
		<HelperText style={hasMessage ? undefined : Styles.form.helperTextHidden} type="error" visible={hasMessage}>
			{message}
		</HelperText>
	);
};

export default FieldError;
